// extracted by mini-css-extract-plugin
export var table = "_yv-0";